/**
 * What every screen in this folder needs: the board's columns, the tone each
 * status is drawn in, and the translator type the leaf components take as a
 * prop.
 */
import type { useT } from "../../../i18n/I18nProvider";
import type { LeadStatus } from "../../../lib/clients";
import type { StatusTone } from "../../ui";

export type T = ReturnType<typeof useT>;

/** The kanban columns, left to right, each with the tint it is drawn in. */
export const STATUSES: { key: LeadStatus; color: string }[] = [
  { key: "new",       color: "bg-zinc-100 dark:bg-zinc-800" },
  { key: "contacted", color: "bg-blue-50 dark:bg-blue-950/40" },
  { key: "qualified", color: "bg-violet-50 dark:bg-violet-950/40" },
  { key: "proposal",  color: "bg-amber-50 dark:bg-amber-950/40" },
  { key: "won",       color: "bg-green-50 dark:bg-green-950/40" },
  { key: "lost",      color: "bg-red-50 dark:bg-red-950/40" },
];

/**
 * The pill each status wears in the table, where there are no tinted columns to
 * say the same thing.
 *
 * A `Record` and not a ternary chain: a seventh status added to `LeadStatus` is
 * then a type error here rather than a row that silently falls into whichever
 * branch was written last and gets drawn as somebody else.
 */
export const STATUS_TONE: Record<LeadStatus, StatusTone> = {
  new: "info",
  contacted: "info",
  qualified: "wt",
  proposal: "wt",
  won: "ok",
  lost: "lt",
};
